module.exports = __webpack_public_path__ + "media/img_article6_tv_video.75b40a8c.mp4";